"use client";

import React from "react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const wp_query_params = {
  per_page: 3,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
function FeaturedReleasesGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="bg-card border-border animate-pulse flex flex-col">
            <AspectRatio ratio={16 / 9} className="bg-muted rounded-t-xl" />
            <CardContent className="p-6 flex-grow">
              <div className="h-6 bg-muted rounded w-3/4 mb-4" />
              <div className="h-4 bg-muted rounded w-1/4 mb-8" />
              <div className="flex justify-between items-end mt-auto">
                <div className="h-8 bg-muted rounded w-1/3" />
                <div className="h-10 bg-muted rounded w-1/3" />
              </div>
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>No featured releases available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="bg-card border-border overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group flex flex-col rounded-xl">
          <Link to={product.link} className="block shrink-0">
            <AspectRatio ratio={16 / 9} className="bg-muted overflow-hidden border-b border-border/50">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-muted text-muted-foreground font-default">
                  Image Unavailable
                </div>}
            </AspectRatio>
          </Link>
          
          <CardContent className="p-6 flex-grow flex flex-col justify-between gap-6">
            <div>
              <Link to={product.link}>
                <CardTitle className="font-default text-xl md:text-2xl text-foreground hover:text-primary transition-colors line-clamp-2 mb-2">
                  {product.title}
                </CardTitle>
              </Link>
              {product.short_description && <div className="text-sm text-muted-foreground line-clamp-2 [&_p]:mb-0 font-default" dangerouslySetInnerHTML={{
            __html: product.short_description
          }} />}
            </div>
            
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mt-auto pt-4 border-t border-border/30 gap-4">
              <div className="font-default text-2xl md:text-3xl font-bold text-accent group-hover:brightness-110 transition-all">
                ${product.price?.toFixed(2) || "0.00"}
              </div>
              <div className="w-full sm:w-auto sm:min-w-[140px] shrink-0">
                <AddToCartButton productId={product.id} showQuantity={false} text="Add to Cart" className="w-full" buttonClassName="bg-primary text-primary-foreground border border-border hover:shadow-md transition-all font-default font-semibold uppercase tracking-wider w-full" />
              </div>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function FeaturedReleases() {
  return <section id="featured-releases" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:text-left">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground uppercase tracking-widest">
            Featured Releases
          </h2>
          <div className="h-1 w-24 bg-primary mt-6 mx-auto md:mx-0 rounded-full shadow-sm" />
        </div>
        
        <EcommerceProductsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <FeaturedReleasesGrid />
        </EcommerceProductsProvider>
      </div>
    </section>;
}